import { useLocation } from "react-router-dom";
import useDriversPage from "../pageHooks/useDriversPage";
import DriversPageContent from "./DriversPageContent";

const AdminDrivers = () => {
    const location = useLocation();

    const {
        driverPageLocation,
        filterModalOpen,
        setFilterModalOpen,
        driversList,
        fetchDriversError,
        paginationState,
        handleFetchDrivers,
        isFetchingDrivers,
        driverStatsData,
        isLoadingDriverStats,
        employmentFilters,
        query,
        setQuery,
    } = useDriversPage(location.pathname);

    return (
        <DriversPageContent
            title="All Drivers"
            driverPageLocation={driverPageLocation}
            filterModalOpen={filterModalOpen}
            setFilterModalOpen={setFilterModalOpen}
            paginationState={paginationState}
            handleFetchDrivers={handleFetchDrivers}
            isFetchingDrivers={isFetchingDrivers}
            driversList={driversList}
            fetchDriversError={fetchDriversError}
            driversStats={driverStatsData}
            isGettingAllDriversStats={isLoadingDriverStats}
            employmentFilters={employmentFilters}
            query={query}
            setQuery={setQuery}
        />
    );
};

export default AdminDrivers;
